import { useContext } from 'react';

import { TimelineContext } from './Timeline';

import { assert } from '../../utils/assert';

import styles from './TimelineMarker.module.scss';

interface TimelineMarkerProps {
    time: Date;
}
const DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
});

export const TimelineMarker = ({ time }: TimelineMarkerProps) => {
    const context = useContext(TimelineContext);
    assert(context, 'Must be used within Timeline compoennt');

    const { isVisible, timeToPosition: timeToPixels, laneHeight } = context;

    if (!isVisible(time.getTime())) {
        return null;
    }

    return (
        <>
            <div
                style={{
                    left: timeToPixels(time.getTime()),
                }}
                className={styles.line}
            />
            <p
                style={{
                    top: laneHeight,
                    left: timeToPixels(time.getTime()),
                }}
                className={styles.text}
            >
                {DATE_FORMAT.format(time)}
            </p>
        </>
    );
};
